module.exports = __webpack_public_path__ + "static/img/cal-diners.b5df4a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos/cal-diners.png
// module id = YAXe
// module chunks = 6